import { UnityData, HeaderContent } from "../../LinkDataInterface";
import { mail, nas, wiki } from "./links";
import bg from "./PL-banniere.png";
import logo from "./PL-logo.png";

const header: HeaderContent = {
  driveSearch: {
    url: "https://drive.google.com/drive/search?q=",
    color: "rgba(63, 28, 69, 0.6)",
    text: "rgb(225, 185, 185)",
  },
  logo: logo,

  quickLinks: [mail, nas, wiki],
};

export const defaultJiData: UnityData = {
  name: "PolyLAN",
  style: {
    button: {
      color: "rgba(225, 185, 185, 0.9)",
      text: "#000000",
      hover: "rgba(63, 28, 69, 0.8)",
      textHover: "rgb(225 185 185)",
    },
    background: {
      imgLandscape: bg,
      imgPortrait: bg,
      color: "#dff4af",
    },
  },
  groups: [],
  header: header,
};
